
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/komodo-wallet/mobile/withdraw-or-send-funds",
      function () {
        return require("private-next-pages/docs/komodo-wallet/mobile/withdraw-or-send-funds/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/komodo-wallet/mobile/withdraw-or-send-funds"])
      });
    }
  